import React, { useEffect, useState } from "react";
import ReactMarkdown from 'react-markdown';
import remarkGfm from "remark-gfm";
import "./CaseStudy.css";
import ftHero from '../assets/images/ft-hero.png';
import { useNavigate } from "react-router-dom";

export default function FoodTracker() {
  const navigate = useNavigate();
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch('/apple-music.md')
      .then(res => res.text())
      .then(setMarkdown);
  }, []);

  return (
    <div className="case-page">

      <button className="case-back" onClick={() => navigate(-1)}>
        <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.5 11.5L2.5 7.5M2.5 7.5L6.5 3.5M2.5 7.5H12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Back to Projects
      </button>

      <div className="case-hero">
        <h1>Apple Music <em>Linked Shuffle</em></h1>
        <p className="case-hero-intro">
          A UX redesign adding a "link" feature to Apple Music's shuffle mode, letting users group songs for back-to-back playback — reducing skips and giving listeners meaningful control over their listening experience.
        </p>
        <div className="case-meta-inline">
          <span><strong>Role</strong>UX Researcher &amp; Designer</span>
          <span><strong>Duration</strong>6 Weeks</span>
          <span><strong>Tools</strong>Figma, FigJam</span>
          <span><strong>Context</strong>Arizona State University</span>
        </div>
      </div>

      <div className="case-hero-img has-image">
        <img src={ftHero} alt="Apple Music Linked Shuffle" />
      </div>

      <div className="case-body">
        <div className="case-section">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {markdown}
          </ReactMarkdown>
        </div>

        <div className="case-divider" />

        <div className="case-section">
          <span className="case-section-num">07 — Presentation</span>
          <h2>Case Study <em>Presentation</em></h2>
          <video controls className="case-video" style={{ width: '100%', borderRadius: '12px', marginTop: '1rem' }}>
            <source src="/videos/apple-music-presentation.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

    </div>
  );
}
